var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-house-suggest" },
    [
      _c("ui-input", {
        ref: "query",
        staticClass: "ui-house-suggest__input",
        attrs: {
          label: _vm.label,
          autocomplete: "off",
          placeholder: _vm.placeholder,
          required: _vm.required,
          validate: "house",
          clearable: ""
        },
        on: { input: _vm.getSuggestions, focus: _vm.onFocus, blur: _vm.onBlur },
        model: {
          value: _vm.query,
          callback: function($$v) {
            _vm.query = $$v
          },
          expression: "query"
        }
      }),
      _c(
        "div",
        { staticClass: "ui-house-suggest__suggestions" },
        [
          _c(
            "ui-dropdown",
            { attrs: { visible: _vm.showSuggestions } },
            _vm._l(_vm.formattedSuggestions, function(suggestion, ind) {
              return _c(
                "div",
                {
                  key: ind,
                  staticClass: "ui-house-suggest__suggestion",
                  on: {
                    click: function($event) {
                      return _vm.select(suggestion)
                    }
                  }
                },
                [
                  _vm._v("\n        " + _vm._s(suggestion.text) + "\n        "),
                  _vm.checkSelected(suggestion)
                    ? _c("f-sprite-icon", {
                        attrs: { "icon-link": _vm.$options.icons.IconCheck.id }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            0
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }